<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
       <el-form-item label="手机号">
        <el-input v-model="queryForm.userPhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getUserList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
            <el-button
                type='primary'
                size='small'
                icon='el-icon-plus'
                @click='addMppAgent'
            >
                新增用户
            </el-button>
            <el-button
                type='warning'
                size='small'
                icon='el-icon-plus'
                @click='changeUserBonusDialog'
            >
                修改用户分红
            </el-button>
        </div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshWarningPersonList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="warningList"
        row-key="id"
        size="small"
      >
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userName"
          label="用户账号"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userMobile"
          label="手机号码"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userNickname"
          label="昵称"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="agentRate"
          label="分红比例"
          min-width="20%"
        >
            <template slot-scope="scope">
                <span>{{ scope.row.agentRate + '%' }}</span>
            </template>
        </el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="agentId"
          label="代理id"
          min-width="20%"
        >
        </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="updateTime"
          label="修改时间"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="isMainAccount"
          label="操作"
          min-width="20%"
        >   
            <template slot-scope="scope">
                <div class='operation'>
                    <div v-if="!scope.row.isMainAccount" @click='deleteMppAgent(scope.row.userId)'>
                        <Icon size='16' style='color: red'>
                            <Delete24Regular />
                        </Icon>
                        <span class='operation-label' style='color: red'>删除</span>
                    </div>
                </div>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="新增用户" :close-on-click-modal="false" :append-to-body="true" :visible.sync="addDialogVisible" width="80%">
        <el-form style="padding: 0; margin: 0;" :inline="true" ref="searchFormDialog" class="query-form" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <el-form-item v-for="(search, index) in searchList" :key="index" :prop="search.prop">
                <el-input size="small" v-model="searchForms[index]" :placeholder="search.label" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchParams()" size="small">查询</el-button>
                <el-button @click="resetSearch()" size="small">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="dialogList"
            v-loading="dialogLoading"
            border
            size="small"
            ref="userTable"
            style="width: 100%"
        >
            <template v-for="(column, index) in dialogColumns">
                <el-table-column
                    v-if="column.img === 'img'"
                    :key="index"
                    :prop="column.prop"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    :label="column.label"
                >
                    <template scope='scope'>
                        <img v-if='scope.row[column.prop]' :src='scope.row[column.prop]' style='width: 80px;height: 80px;margin: auto;'>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else
                    :key="index"
                    :prop="column.prop"
                    header-align="center"
                    align="center"
                    min-width="100px"
                    :label="column.label"
                >
                <!-- 修改部分 -->
                    <template slot-scope="scope">
                        <div v-if="column.children == undefined">{{ scope.row[column.prop] }}</div>
                        <div v-else>
                            <div style="text-align:left" v-for="(item,key) in column.children">{{ item.label }}: {{ scope.row[item.prop] }}</div>
                        </div>
                    </template>
                <!-- 修改结束部分 -->
                </el-table-column>
            </template>
            <el-table-column
                align="center"
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                    <el-button @click="selectionChangeHandleSingle(scope.row)" type="text" size="small">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageDialogNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageDialogSize"
            :total="pageDialogTotalNum"
            layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
    </el-dialog>

    <el-dialog title="修改用户分红"
        :visible.sync="updateUserBonusVisible"
        width="80%"
        :close-on-click-modal="false"
        :append-to-body="true" 
        @closed="closeUpdateUserBonus()"
    >
        <el-form ref="updateUserBonusForm" style="padding: 0; margin: 0;" :inline="true" class="query-form" >
            <el-form-item label="手机号">
                <el-input size="small" v-model="updateUserBonusForm.mobile" placeholder="手机号" clearable />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="updateUserBonusSearch()" size="small">查询</el-button>
                <el-button @click="resetUpdateUserBonusSearch()" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 查询表格 -->
        <el-table
            :data="updateUserBonusSearchList"
            v-loading="updateUserBonusSearchLoading"
            border
            size="small"
            ref="userTable"
            style="width: 100%"
        >
            <el-table-column prop="userName" label="账号" />
            <el-table-column prop="userNickname" label="昵称" />
            <el-table-column prop="userMobile" label="手机号" />
            <el-table-column prop="userNickname" label="昵称" />
            <el-table-column prop="agentRate" label="分成">
                <template slot-scope="scope">
                    {{ scope.row.agentRate }}%
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                fixed="right"
                label="操作"
                min-width="100">
                <template slot-scope="scope">
                    <el-button @click="updateUserBonusSearchTableFn(scope.row)" type="text" size="small">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 最终修改表格数据 -->
        <el-table
            :data="updateUserBonusFinallyData"
            border
            size="small"
            ref="userTable"
            style="width: 100%"
        >
            <el-table-column prop="userNickname" label="昵称" min-width="20%" />
            <el-table-column prop="userMobile" label="手机号" min-width="20%"  />
            <el-table-column prop="agentRate" label="修改前比例" min-width="20%" >
                <template slot-scope="scope">
                    {{ scope.row.agentRate }}%
                </template>
            </el-table-column>
            <el-table-column
                prop="agentRateUpdated"
                label="修改后比例"
                min-width="20%"
            >
                <template slot-scope="scope">
                    <!-- <el-input type="number" v-model="scope.row.agentRateUpdated" /> -->
                    <el-input-number type="number" v-model="scope.row.agentRateUpdated" />
                </template>
            </el-table-column>
            <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='100'
                >
                <template slot-scope='scope'>
                    <div class='operation'>
                        <div @click='usdateUserDel(scope.row.id)'>
                            <Icon size='16' style='color: red'>
                                <Delete24Regular />
                            </Icon>
                            <span class='operation-label' style='color: red'>删除</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <span slot='footer' class='dialog-footer'>
            <el-button>取 消</el-button>
            <el-button type='primary' @click="confirmFn">确 定</el-button>
        </span>

    </el-dialog>

  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search, Disabled } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, postJson } from '@/utils/request.js';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data() {
        return {
            queryForm: {
                userPhone: ''
            },
            loading: false,
            isSearch: false,
            pageSize: 20,
            currentPage: 1,
            totalNum: 0,
            warningList: [],
            addDialogVisible:false,//新增弹框
            searchForms:[],//新增弹框 搜索数据
            searchList:USER_SEARCH,//新增弹框 搜索列表
            dialogColumns:USER,//新增弹框 表格columns
            pageDialogNum:1,//新增弹框 当前页数
            pageDialogSize:10,//新增弹框 每页条数
            pageDialogTotalNum:0,//新增弹框 列表总计
            dialogList:[],//新增弹框 列表数据
            dialogLoading: false,//新增弹框 loading效果
            updateUserBonusVisible: false,//修改用户弹框
            updateUserBonusForm:{
                mobile:''
            },//修改用户弹框 表单数据
            updateUserBonusSearchList:[],//修改用户弹框 查询表格
            updateUserBonusSearchLoading: false,//修改用户弹框 查询表格 loading效果
            currentUpdateUserInfo:{},//修改用户弹框 当前选择的用户信息
            updateUserBonusFinallyData:[], // 修改用户弹框 最终提交数据
        };
    },
    created() {
        this.agentId  = this.$route.query.agentId;
        this.getUserList();
    },
    methods: {
        // 关闭弹框
        closeUpdateUserBonus(){
            this.updateUserBonusForm = {
                mobile: '',
            }
            this.updateUserBonusSearchList = [];
            this.updateUserBonusFinallyData = [];
            this.$refs.updateUserBonusForm.resetFields();
        },
        // 修改用户分红 删除
        usdateUserDel(id){
            let index = this.updateUserBonusFinallyData.findIndex(item=>item.id == id)
            this.updateUserBonusFinallyData.splice(index,1)
        },
        // 修改用户分红弹框确认
        confirmFn(){
            postJson('/agent/user/updateAgentUser',this.updateUserBonusFinallyData.map(item=>{
                return {
                    agentId : item.agentId,
                    userId : item.userId,
                    agentRate : Number(item.agentRateUpdated)
                }
            })).then(res=>{
                if(res.success){
                    this.$message.success(res.msg)
                    this.updateUserBonusVisible = false;
                    this.getUserList()

                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        // 修改用户分红弹框  查询
        updateUserBonusSearch(){
            if(!this.updateUserBonusForm.mobile){
                this.$message.error('手机号不能为空')
                return
            }
            post('/agent/user/queryAgentUserByUserId',{
                agentId : this.agentId,
                userPhone : this.updateUserBonusForm.mobile,
                userIds:this.updateUserBonusFinallyData.map(item=>item.id)
            }).then((res) => { 
                if(res.success){
                    this.updateUserBonusSearchList = res.list || [];
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        // 修改用户分红弹框  重置
        resetUpdateUserBonusSearch(){
            this.updateUserBonusForm = {
                mobile: '',
            }
            this.$refs.updateUserBonusForm.resetFields();
            this.updateUserBonusSearch();
        },
        // 修改用户分红弹框选择数据
        updateUserBonusSearchTableFn(row){
            this.updateUserBonusFinallyData.push({
                ...row,
                agentRateUpdated:row.agentRate
            })
        },
        // 打开修改用户分红弹框
        changeUserBonusDialog(){
            this.updateUserBonusVisible = true;
        },
        // 新增弹框内的选择按钮
        selectionChangeHandleSingle(row){
            post('/agent/user/insert', {
                agentId : this.agentId,
                userId : row.id
            }).then(res=>{
                if(res.success){
                    this.getUserList();
                    this.addDialogVisible = false;
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageDialogSize = val;
            this.pageDialogNum = 1;
            this.refreshList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageDialogNum = val;
            this.refreshList();
        },
        // 新增弹框刷新
        refreshList(){
            this.dialogLoading = true;
            let searchForm = {};
            this.searchList.forEach((search, index) => {
                searchForm[search.prop] = this.searchForms[index];
            });
            get('/mpp/user/findList', { ...searchForm, pageNum: this.pageDialogNum, pageSize: this.pageDialogSize }).then((res) => {
                if (res.success) {
                    this.dialogList = res.page.list;
                    this.pageDialogTotalNum = res.page.total;
                    this.dialogLoading = false;
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        // 新增弹框查询
        searchParams(){
            this.pageDialogNum = 1;
            this.refreshList()
        },
        // 新增弹框重置
        resetSearch(){
            this.$refs.searchFormDialog.resetFields();
            this.searchForms = [];
            this.pageDialogNum = 1;
            this.refreshList();
        },
        // 点击新增用户按钮
        addMppAgent(){
            this.addDialogVisible = true;
            this.dialogLoading = true;
            get('/mpp/user/findList', { pageNum: this.pageDialogNum, pageSize: this.pageDialogSize }).then((res) => {
                if (res.success) {
                    this.dialogList = res.page.list;
                    this.pageDialogTotalNum = res.page.total;
                    this.dialogLoading = false;
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        // 是否展示搜索项
        search() {
            this.isSearch = !this.isSearch;
        },
        // 删除
        deleteMppAgent(id){
            post('/agent/user/deleteAgentUser', {
                agentId : this.agentId,
                userId: id
            }).then(res=>{
                if(res.success){
                    this.$message.success(res.msg);
                    this.getUserList()
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        // 获取列表数据
        getUserList() {
            this.loading = true;
            get(`/agent/user/queryList`, { 
                ...this.queryForm, 
                pageNum: this.currentPage, 
                pageSize: this.pageSize,
                agentId : this.agentId
            }).then((res) => {
                this.loading = false;
                if (res.success && res.list) {
                    this.warningList = res.list.list || [];
                    this.totalNum = res.list.total || 0;
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        // 清空搜索信息
        resetQueryFrom() {
            this.queryForm.userPhone = '';
            this.getUserList();
        },
        // 重置列表数据
        resetWarningPersonList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.warningList = [];
        },
        // 刷新列表数据
        refreshWarningPersonList() {
            this.resetWarningPersonList();
            this.getUserList();
        },
        // 当前页码更改
        currentChange(page) {
            this.currentPage = page;
            this.getUserList();
        },
        // 查询条数更改
        sizeChange(size) {
            this.pageSize = size;
            this.getUserList();
        }
    }
};
</script>

<style lang="scss" scoped>

.page-content{
    height: 100%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
